<template>
  <div class="part-panel" v-if="title">
    <div class="panel-title" >
      <span class="title-icon"></span><span class="title">{{title}}</span><slot name="legend"></slot>
      <div class="panel-tips" v-if="num>0">
        <span>
          提示：您有{{num}}台资源的安仔服务过期或即将过期
        </span>
        <Icon type="ios-information-circle" size="28"/>
      </div>
    </div>
    <div class="panel-body">
      <slot></slot>
    </div>
  </div>
  <div class="part-panel" v-else>
    <div class="panel-body-total">
      <slot></slot>
    </div>
  </div>
  
</template>
<script>
  export default{
    name:"PartPanel",
    props:['title','num'],
    mounted(){}
  }
</script>


// WEBPACK FOOTER //
// src/components/panel/PartPanel.vue